var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoUserinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.89 15.6"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.92 8.75a4.74 4.74 0 10-4.92 0c-2.92.66-5 2.44-5 4.61 0 1.77 4.68 2.24 7.45 2.24s7.44-.47 7.44-2.24c0-2.17-2.05-3.95-4.97-4.61zm-6.23-4a3.76 3.76 0 113.76 3.73 3.75 3.75 0 01-3.76-3.75zm3.76 9.9c-4 0-6.36-.84-6.47-1.27 0-2.15 2.9-3.9 6.47-3.9s6.46 1.74 6.47 3.9c-.11.41-2.49 1.25-6.47 1.25z",
    fill: "#fdc800",
    "data-name": "Capa 1"
  }))));
}

export default SvgCoUserinline;